import { render, staticRenderFns } from "./AfaElettrocardiogrammaViewComponent.vue?vue&type=template&id=58789bd4"
import script from "./AfaElettrocardiogrammaViewComponent.vue?vue&type=script&lang=js"
export * from "./AfaElettrocardiogrammaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports